import React from 'react'
import { useHookstate } from '@hookstate/core'
import { Card, CardContent, Grid, Typography } from '@mui/material'
import Map from '~/features/Map/components/Map'
import { useLang } from '~/hooks/useLang'
import HeatMapDispatchLayer from '../../components/HeatMapDispatchLayer'
import FilterDispatchHotMap from '../FilterDispatchHotMap'
import MapMarkersEvents from '~/features/Map/components/MapMarkers/MapMarkersEvents'
import AreaPlans from '~/features/Map/components/AreaPlans'
import FiltersInMap from './components'

type PayloadProps = {
  readonly withSolvedThirdParty?: boolean
  readonly exludeClosed?: boolean
}

export default function DispatchHotMap({
  agencyId,
  searched,
  deviceId,
  operationId,
  dispatchGroupId,
  category,
  type,
  subtype,
  dateStart,
  dateFinish,
  thirdParty,
  refresh,
  consummated,
  statusIds,
  cityIds,
  groupSetId,
  location,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  expandFilterSearch,
  operationUnitId,
  phone,
  requester,
  userId,
  districtIds,
  geographicalArea,
  locationAccuracy,
  selectIsValidatedTypeMap,
  startTime,
  endTime,
}) {
  const { translate } = useLang()
  const refreshHotMap = useHookstate(false)
  const viewGroups = useHookstate(['camera', 'dispatchHeatMap'])
  const loading = useHookstate(false)
  const showHeatMap = useHookstate(true)
  const payload = useHookstate<PayloadProps>({
    withSolvedThirdParty: thirdParty,
    exludeClosed: false,
  })
  const heatMapDispatchs = {
    agencyId,
    deviceId,
    operationId,
    dispatchGroupId,
    category,
    type,
    subtype,
    dateStart,
    dateFinish,
    payload: payload.get(),
    consummated,
    statusIds,
    cityIds,
    groupSetId,
    location,
    closedStatusClassId,
    closedStatusId,
    qualifierOptions,
    operationUnitId,
    locationAccuracy,
    phone,
    requester,
    userId,
    geographicalArea,
    districtIds
  }

  return (
    <Grid
      container
      xs={12}
      sx={{
        display: 'flex',
        paddingX: 3,
        paddingTop: 3,
      }}
    >
      <Card variant="outlined" sx={{ width: '100%', overflowX: 'auto' }}>
        <CardContent sx={{ height: '80%' }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>
            {translate('Map View')}
          </Typography>

          <FilterDispatchHotMap
            expandFilterSearch={expandFilterSearch}
            locationAccuracy={locationAccuracy}
            refreshHotMap={refreshHotMap}
            refresh={refresh}
            loading={loading}
            selectIsValidatedTypeMap={selectIsValidatedTypeMap}
            heatMapDispatchs={heatMapDispatchs}
            showHeatMap={showHeatMap}
          />
          <Grid item xs={12} hidden={!expandFilterSearch} paddingY={4}>
            <Map enableLayerControl={false}>
              <FiltersInMap />
              <MapMarkersEvents
                viewGroups={viewGroups.value}
                checkedViewGroups={viewGroups.value}
              />
              <AreaPlans />
              {showHeatMap.get() &&
                <HeatMapDispatchLayer
                  agencyId={agencyId}
                  searched={searched}
                  operationId={operationId}
                  deviceId={deviceId}
                  dispatchGroupId={dispatchGroupId}
                  category={category}
                  type={type}
                  subtype={subtype}
                  dateStart={dateStart}
                  dateFinish={dateFinish}
                  thirdParty={thirdParty}
                  refresh={refresh}
                  consummated={consummated}
                  statusIds={statusIds}
                  cityIds={cityIds}
                  districtIds={districtIds}
                  groupSetId={groupSetId}
                  location={location}
                  closedStatusClassId={closedStatusClassId}
                  closedStatusId={closedStatusId}
                  qualifierOptions={qualifierOptions}
                  operationUnitId={operationUnitId}
                  locationAccuracy={locationAccuracy.get()}
                  selectIsValidatedTypeMap={selectIsValidatedTypeMap.get()}
                  refreshHopMap={refreshHotMap.get()}
                  loading={loading}
                  phone={phone}
                  requester={requester}
                  userId={userId}
                  geographicalArea={geographicalArea}
                  startTime={startTime}
                  endTime={endTime}
                />
              }
            </Map>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  )
}
